import { clearAllModuleTimers } from '@/store/slices/poc/messagingSlice';
import type { AppServices } from '@/types/shared/services.types';

/**
 * Register a global beforeunload handler that performs best-effort cleanup
 * when the user closes the tab or navigates away. This is fire-and-forget —
 * the browser may kill the page before async work completes.
 *
 * Note: Do NOT clear the session token here — beforeunload fires on refresh
 * too, which would log the user out. Token cleanup belongs in logoutThunk.
 */
export function registerBeforeUnloadHandler(getServices: () => AppServices): void {
  window.addEventListener('beforeunload', () => {
    clearAllModuleTimers();

    // Fire-and-forget — beforeunload cannot await async work.
    // The browser may kill the page before shutdown completes.
    void getServices().pocServices.p2pStackManagerService.shutdownAllStacks();
  });
}
